import type { IValidatorParams } from "@edaz/services/baseValidationService";

export interface IsTextWithoutAccentsOptions {
  validate?: (entity: any) => boolean;
}

export default function isTextWithoutAccents(
  value: string | undefined,
  options: IsTextWithoutAccentsOptions,
  params?: IValidatorParams
) {
  if (options.validate && !options.validate(params?.entity)) {
    return true;
  }

  const regex = /^([a-zA-Z]|[ ])*$/;

  if (value) {
    return regex.test(value);
  }

  return true;
}
